import { defineComponent as _defineComponent } from 'vue'
import Filters, { FiltersProps } from '@/components/organism/filters/Filters.vue';
import TableContainer, { TableContainerProps } from '@/components/molecules/table/TableContainer.vue';
import Paginator, { PaginatorProps } from '@/components/molecules/paginator/Paginator.vue';
import Action, { ActionProps } from '@/components/atoms/action/Action.vue';

interface PageListProps {
    title: string;
    subtitle: string;
    filters: FiltersProps;
    table: TableContainerProps;
    isLoading?: boolean;
    paginator: PaginatorProps;
    actions?: ActionProps[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListPage',
  props: {
    title: null,
    subtitle: null,
    filters: null,
    table: null,
    isLoading: { type: Boolean },
    paginator: null,
    actions: null
  },
  setup(__props: any) {

const props = __props as {
    title: string;
    subtitle: string;
    filters: FiltersProps;
    table: TableContainerProps;
    isLoading?: boolean;
    paginator: PaginatorProps;
    actions?: ActionProps[]
};



return { __sfc: true,props, Filters, TableContainer, Paginator, Action }
}

})